import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from '../input/input';

/** Percentage-suffixed input — thin composition over `InputComponent`'s existing decimal formatting (SCRUM-1228). */
@Component({
  selector: 'lib-percent-input',
  imports: [ReactiveFormsModule, InputComponent],
  templateUrl: './percent-input.html',
})
export class PercentInput {
  @Input({ alias: 'control' }) control!: FormControl;
  @Input({ alias: 'label' }) label: string = '';
  @Input({ alias: 'secondaryLabel' }) secondaryLabel: string = '';
  @Input({ alias: 'placeholder' }) placeholder: string = 'Input percentage';
  @Input({ alias: 'id' }) id: string = '';
  @Input({ alias: 'errorMessage' }) errorMessage?: string;
  @Input({ alias: 'inputClass' }) inputClass: string = '';
  @Input({ alias: 'labelClass' }) labelClass: string = '';
}
